import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import get from 'lodash/get';
import { FontIcon } from 'office-ui-fabric-react/lib/Icon';
import { Text } from 'office-ui-fabric-react/lib/Text';
import { fetchPartners } from '../../actions/partners';
import { fetchTransactionsStats } from '../../actions/transactions';
import Module from '../../components/Module';
import ModuleContent from '../../components/ModuleContent';
import PageTitle from '../../components/PageTitle';
import Main from '../../components/Main';
import TransactionsStats from '../../components/TransactionsStats';
import styles from './TransactionListing.style';
import { getUser } from '../../utils/auth';

const TransactionListing = () => {
  const dispatch = useDispatch();
  // leaving this for now, not sure how the logic on this page changes in the future
  const isPartner = !get(getUser(), 'profile.roles', []).includes('msft');
  const { totalEarnedRoyalty, totalTransactionsQuantity, statementDates } = useSelector(state =>
    get(state, 'pagination.transactionsStats', {}),
  );
  const contracts = useSelector(state => get(state, 'entities.contracts', {}));
  const contractAddress =
    Object.keys(contracts).length > 0 ? Object.values(contracts)[0].address : null;
  const partnerAddress =
    Object.keys(contracts).length > 0 ? Object.values(contracts)[0].partnerAddress : null;

  useEffect(() => {
    if (isPartner) {
      dispatch(fetchPartners());

      if (partnerAddress) {
        dispatch(fetchTransactionsStats({ contractAddress, partnerAddress }));
      }
    }
  }, [dispatch, isPartner, contractAddress, partnerAddress]);

  return (
    <>
      {isPartner ? (
        <>
          <PageTitle>Transactions</PageTitle>
          <Main>
            <TransactionsStats
              totalEarnedRoyalty={totalEarnedRoyalty}
              totalTransactionsQuantity={totalTransactionsQuantity}
              statementDates={statementDates}
              currency="USD"
              noTransactionDataMessage="Transactions have not yet been processed since the last statement."
            />
          </Main>
        </>
      ) : (
        <div className={styles.fullWidthLimit}>
          <PageTitle fullWidth>Transactions</PageTitle>
          <Main fullWidth>
            <Module>
              <ModuleContent>
                <div className={styles.iframeContainer}>
                  <iframe
                    sandbox
                    className={styles.iframe}
                    src={window.config.powerBITransactionsURL}
                    frameBorder="0"
                    title="PowerBI"
                  />
                </div>
              </ModuleContent>
              <div className={styles.infoMessage}>
                <FontIcon
                  iconName="Info"
                  ariaLabel="Info"
                  id="select-partner-icon"
                  className={styles.infoIcon}
                />
                <Text as="p" className={styles.infoText}>
                  These transactions can be up to 12 hours behind the transactions summary displayed
                  on the contract page.
                </Text>
              </div>
            </Module>
          </Main>
        </div>
      )}
    </>
  );
};

export default TransactionListing;
